import React from 'react';
import { AuthorizedImage } from '@/components/AuthorizedImage';
import type { PhotoGalleryItem } from '@/components/PhotoGallery/PhotoGallery.types';

interface CarMainImageProps {
  make: string;
  model: string;
  imageUrl: string;
  mainPhoto?: PhotoGalleryItem;
}

export const CarMainImage: React.FC<CarMainImageProps> = ({
  make,
  model,
  imageUrl,
  mainPhoto,
}) => {
  const resolvedImageUrl = mainPhoto
    ? mainPhoto.fullSizeState === 'placeholder'
      ? mainPhoto.src
      : mainPhoto.fullSrc || mainPhoto.src
    : imageUrl;

  React.useEffect(() => {
    mainPhoto?.requestThumbnail?.();
    mainPhoto?.requestFullSize?.();
  }, [mainPhoto]);

  return (
    <div className="w-full max-w-[404px] rounded-[25px] text-zinc-800 shadow-2xl">
      <div className="flex flex-col px-5 py-5 pt-6 w-full bg-white rounded-3xl">
        <div className="flex gap-2 self-start">
          <div className="text-base font-semibold leading-none grow">
            {make}
          </div>
          <div className="text-sm tracking-wide leading-none">{model}</div>
        </div>
        <AuthorizedImage
          src={resolvedImageUrl}
          alt={`${make} ${model}`}
          className="mt-5 aspect-[1.71] w-full rounded-none object-contain"
          skeletonClassName="mt-5 aspect-[1.71] w-full rounded-none animate-pulse bg-gray-200"
          onError={() => mainPhoto?.refreshVariant?.('LARGE')}
        />
      </div>
    </div>
  );
};
